"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WithThemeQueriesType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _themeProvider = require("@gravity/theme-provider");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["forwardedRef"];
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withThemeQueries.js",
  _this = void 0;
function cov_11fflb9als() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withThemeQueries.js";
  var hash = "5a44646e38ce6d966760d57f33fe3262479fad3c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withThemeQueries.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "2": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 10,
          column: 5
        }
      },
      "3": {
        start: {
          line: 14,
          column: 24
        },
        end: {
          line: 14,
          column: 86
        }
      },
      "4": {
        start: {
          line: 14,
          column: 81
        },
        end: {
          line: 14,
          column: 86
        }
      },
      "5": {
        start: {
          line: 16,
          column: 25
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "6": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "7": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 24,
          column: 6
        }
      },
      "8": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 28,
          column: 16
        }
      },
      "9": {
        start: {
          line: 27,
          column: 39
        },
        end: {
          line: 27,
          column: 82
        }
      },
      "10": {
        start: {
          line: 31,
          column: 36
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "11": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 36,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 24
          },
          end: {
            line: 5,
            column: 25
          }
        },
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 5
          }
        },
        loc: {
          start: {
            line: 7,
            column: 21
          },
          end: {
            line: 10,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 24
          },
          end: {
            line: 14,
            column: 25
          }
        },
        loc: {
          start: {
            line: 14,
            column: 81
          },
          end: {
            line: 14,
            column: 86
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 26
          }
        },
        loc: {
          start: {
            line: 16,
            column: 63
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 16
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 21
          }
        },
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 24,
            column: 6
          }
        },
        line: 19
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 24
          }
        },
        loc: {
          start: {
            line: 27,
            column: 39
          },
          end: {
            line: 27,
            column: 82
          }
        },
        line: 27
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        loc: {
          start: {
            line: 33,
            column: 21
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 41
          },
          end: {
            line: 5,
            column: 88
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 5,
            column: 67
          },
          end: {
            line: 5,
            column: 88
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 41
          },
          end: {
            line: 14,
            column: 74
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 53
          },
          end: {
            line: 14,
            column: 74
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 28,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 83
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 15
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5a44646e38ce6d966760d57f33fe3262479fad3c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11fflb9als = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11fflb9als();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_11fflb9als().s[0]++;
var getThemeQueries = function getThemeQueries(_ref) {
  var _ref$themeContext = _ref.themeContext,
    _ref$themeContext2 = _ref$themeContext === void 0 ? (cov_11fflb9als().b[0][0]++, _themeProvider.DEFAULT_THEME_CONTEXT) : _ref$themeContext,
    currentTheme = _ref$themeContext2.theme;
  cov_11fflb9als().f[0]++;
  cov_11fflb9als().s[1]++;
  return (0, _keys.default)(_themeProvider.TicketShopTheme).reduce(function (acc, theme) {
    cov_11fflb9als().f[1]++;
    cov_11fflb9als().s[2]++;
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, theme, theme === currentTheme));
  }, {});
};
cov_11fflb9als().s[3]++;
var getCurrentTheme = function getCurrentTheme(_ref2) {
  var _ref2$themeContext = _ref2.themeContext,
    _ref2$themeContext2 = _ref2$themeContext === void 0 ? (cov_11fflb9als().b[1][0]++, _themeProvider.DEFAULT_THEME_CONTEXT) : _ref2$themeContext,
    theme = _ref2$themeContext2.theme;
  cov_11fflb9als().f[2]++;
  cov_11fflb9als().s[4]++;
  return theme;
};
cov_11fflb9als().s[5]++;
var withThemeQueries = function withThemeQueries(EnhancedComponent, useForwardRef) {
  cov_11fflb9als().f[3]++;
  cov_11fflb9als().s[6]++;
  // eslint-disable-next-line react/prop-types
  var Component = function Component(_ref3) {
    var forwardedRef = _ref3.forwardedRef,
      props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
    cov_11fflb9als().f[4]++;
    cov_11fflb9als().s[7]++;
    return /*#__PURE__*/_react.default.createElement(EnhancedComponent, (0, _extends2.default)({}, props, {
      currentTheme: getCurrentTheme(props),
      themeQueries: getThemeQueries(props),
      ref: forwardedRef,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 5
      }
    }));
  };
  cov_11fflb9als().s[8]++;
  return useForwardRef ? (cov_11fflb9als().b[2][0]++, /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    cov_11fflb9als().f[5]++;
    cov_11fflb9als().s[9]++;
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
      forwardedRef: ref,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 40
      }
    }));
  })) : (cov_11fflb9als().b[2][1]++, Component);
};
var WithThemeQueriesType = exports.WithThemeQueriesType = (cov_11fflb9als().s[10]++, _propTypes.default.shape((0, _keys.default)(_themeProvider.TicketShopTheme).reduce(function (acc, theme) {
  cov_11fflb9als().f[6]++;
  cov_11fflb9als().s[11]++;
  return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, theme, _propTypes.default.bool));
}, {})));
var _default = exports.default = withThemeQueries;